var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 0C2.692 0 0 2.692 0 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6Zm-.56 2.438c0-.104.084-.188.188-.188h.744c.104 0 .188.084.188.188v4.5a.188.188 0 0 1-.188.187h-.744a.188.188 0 0 1-.188-.188v-4.5ZM6 9.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
})));
export default SvgWarning;